import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Button, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { getAppIntegrationAuthUrl, getIntegrationAppLabel } from 'helpers';
import { IntegrationApp } from 'queries';

import { useStyles } from './add-integration-form.styles';

type Props = {
  onExitClick?: () => void;
  availableIntegrationOptions?: IntegrationApp[];
};

export const AddIntegrationForm = ({ onExitClick, availableIntegrationOptions }: Props) => {
  const classes = useStyles();
  const [selectedValue, setSelectedValue] = useState<IntegrationApp | undefined>(undefined);
  const { portalId } = useParams<Record<string, string>>();

  const handleOnSelectIntegrationClick = () => {
    if (!selectedValue) {
      return;
    }
    const redirectUrl = getAppIntegrationAuthUrl(selectedValue, portalId);
    window.open(redirectUrl, '_blank');
  };

  const handleSelectOnChange = (event: any) => {
    if (!event.target.value) {
      setSelectedValue(undefined);
    }
    setSelectedValue(event.target.value as IntegrationApp);
  };

  const getMenuItems = () => {
    if (!availableIntegrationOptions?.length) {
      return (
        <MenuItem selected value={undefined}>
          No Integrations Available
        </MenuItem>
      );
    }
    return availableIntegrationOptions.map((integration: IntegrationApp, index: number) => {
      return (
        <MenuItem key={index} value={integration}>
          {getIntegrationAppLabel(integration)}
        </MenuItem>
      );
    });
  };

  return (
    <Box className={classes.container}>
      <FormControl fullWidth>
        <InputLabel id="dropdown-label">Select Integration</InputLabel>
        <Select
          labelId="integrationDropdown-label"
          id="integrationDropdown"
          value={selectedValue}
          label="Select Integration"
          placeholder="Select Integration"
          onChange={handleSelectOnChange}
        >
          {getMenuItems()}
        </Select>
      </FormControl>
      <Box className={classes.modalFooter}>
        <Button variant="outlined" onClick={onExitClick}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={!selectedValue}
          onClick={handleOnSelectIntegrationClick}
        >
          Select
        </Button>
      </Box>
    </Box>
  );
};
